import React from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames';
import { PLACEMENTS, SIZES, TEXT_LENGTH, TYPES } from './constants';
import { TOOLTIP_PROP_TYPES } from './types';

const getSizeByTextLength = (length) => {
  if (length > TEXT_LENGTH.small && length <= TEXT_LENGTH.medium) {
    return SIZES.medium;
  }

  if (length > TEXT_LENGTH.medium) return SIZES.large;

  return null;
};

const Tooltip = ({ text, type = TYPES.solid, placement = PLACEMENTS.top, id }) => {
  const size = getSizeByTextLength(text.length);
  const classes = classNames('ws-ui-tooltip', {
    [`ws-ui-tooltip--${size}`]: size,
  });

  return (
    <ReactTooltip
      id={id}
      arrowColor="transparent"
      className={classes}
      effect={type}
      place={placement}
    >
      {text}
    </ReactTooltip>
  );
};

Tooltip.hide = () => ReactTooltip.hide();
Tooltip.rebuild = () => ReactTooltip.rebuild();

Tooltip.propTypes = TOOLTIP_PROP_TYPES;

export default Tooltip;
